









































import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'
import { defineComponentTranslations } from '~/utils/i18n'
import { timeDistanceFromNow } from '~/utils/date'
import { useI18n } from '~/compositions/i18n'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { AccessToggleName } from '~/models/user/access-toggles'
import { ClassifiedSaleRequests } from '~/models/classified/types'

export default defineComponent({
  props: {
    saleRequests: {
      type: Object as PropType<ClassifiedSaleRequests>,
      required: true
    }
  },
  setup(props) {
    const { locale, t } = useI18n()

    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)

    const userIsSingle = computed(() => userGetters('isSingle'))

    const userIsBuyer = computed(() =>
      userGetters('userHasAccessTo')(AccessToggleName.SALE_REQUESTS_BUY)
    )

    const timeDistanceToExpirationDate = computed(() =>
      timeDistanceFromNow(props.saleRequests.expirationDate, {
        locale,
        unit: 'hour',
        strict: true
      })
    )

    const classifiedHiddenReasonMessage = computed(() =>
      props.saleRequests.activeSaleRequestStatus === 'completed'
        ? t('completed_sale_request')
        : t('pending_sale_request')
    )

    return {
      userIsBuyer,
      userIsSingle,
      timeDistanceToExpirationDate,
      classifiedHiddenReasonMessage
    }
  },
  i18n: defineComponentTranslations({
    completed_sale_request: {
      en: 'there is a completed sale request',
      el: 'υπάρχει ένα ολοκληρωμένο αίτημα πώλησης.'
    },
    pending_sale_request: {
      en: 'there is an active sale request',
      el: 'υπάρχει ένα ενεργό αίτημα πώλησης.'
    },
    classified_hidden_sale_request: {
      en: 'This classified is hidden from users because',
      el: 'Αυτή η αγγελία δεν εμφανίζεται στους χρήστες επειδή'
    },
    classified_shown_automatically_after: {
      en: 'The classified will be shown automatically',
      el: 'Η αγγελία θα εμφανιστεί αυτόματα'
    },
    view_buy_requests: {
      en: 'View buy requests',
      el: 'Δες τα αιτήματα αγοράς'
    }
  })
})
